import React, { Fragment, useEffect } from 'react'
import { WebhookSubscriber } from '../../../interfaces/Webhook'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import { getWebhook, updateWebhook } from '../config/api'
import { WebhookSubscriberForm } from './WebhookSubscriberForm'
import { Modal } from '../../../components/_EOS/Modal'
import { useModal } from '../../../hooks/useModal'
import { ConfirmAction } from '../../../components/ConfirmAction'
import { Typography } from '@mui/material'

interface WebhookFormEditProps {
  webhookSubscriber: WebhookSubscriber
  closeModal: (sucess: boolean) => void
  handleSnackbar: (message: string, success: boolean) => void
}

export const WebhookFormEdit: React.FC<WebhookFormEditProps> = ({
  webhookSubscriber,
  closeModal,
  handleSnackbar
}) => {
  const { state, callApi } = useApi()
  const {
    state: webhookSubscriberState,
    callApi: getWebhookSubscriberCallApi
  } = useApi<WebhookSubscriber>()

  const requestUpdateWebhook = (dto: WebhookSubscriber) => {
    callApi(updateWebhook(webhookSubscriber.webhookSubscriberId, dto))
      .then(() => {
        handleSnackbar('Webhook editado correctamente', true)
        closeModal(true)
      })
      .catch((error) => {
        handleSnackbar(error, false)
        closeModal(false)
      })
  }

  const [initialState, setInitialState] = React.useState<WebhookSubscriber>()

  const confirmUpdateModal = useModal<WebhookSubscriber>(
    'Confirmar Modificación'
  )

  useEffect(() => {
    requestGetWebhookSubscriber()
  }, [])

  const requestGetWebhookSubscriber = () => {
    getWebhookSubscriberCallApi(
      getWebhook(webhookSubscriber.webhookSubscriberId)
    )
      .then((response) => setInitialState(response))
      .catch((err) => console.log(err))
  }

  if (
    initialState === undefined ||
    state.status === Status.Loading ||
    webhookSubscriberState.status === Status.Loading
  ) {
    return <Loading />
  }

  return (
    <Fragment>
      <WebhookSubscriberForm
        initialValues={initialState}
        onSubmit={(el) => confirmUpdateModal.openModal('sm', el)}
      />

      <Modal
        open={confirmUpdateModal.isOpen}
        onClose={confirmUpdateModal.closeModal}
        title={confirmUpdateModal.title}
        maxWidth={confirmUpdateModal.size}
      >
        <ConfirmAction
          confirmTitle='¿Desea guardar los cambios?'
          confirmText='Confirmar'
          negateText='Cancelar'
          handleSubmitAction={() => {
            if (confirmUpdateModal.extendedProps) {
              requestUpdateWebhook(confirmUpdateModal.extendedProps)
              confirmUpdateModal.closeModal()
            }
          }}
          handleCloseModal={confirmUpdateModal.closeModal}
        >
          <Typography variant='body1' align='center'>
            <strong>
              Si eliminó algún header o cambió la configuración, esta acción
              reemplazará los datos actuales.
            </strong>
          </Typography>
        </ConfirmAction>
      </Modal>
    </Fragment>
  )
}
